var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C3A5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65924 12.7431C4.3714 12.4553 4.3714 11.9886 4.65924 11.7007L9.47772 6.88223C9.76557 6.59439 10.2323 6.59439 10.5201 6.88223L15.3386 11.7007C15.6264 11.9886 15.6264 12.4553 15.3386 12.7431C15.0507 13.0309 14.584 13.0309 14.2962 12.7431L9.99892 8.44582L5.70163 12.7431C5.41379 13.0309 4.94709 13.0309 4.65924 12.7431Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65924 12.7431C4.3714 12.4553 4.3714 11.9886 4.65924 11.7007L9.47772 6.88223C9.76557 6.59439 10.2323 6.59439 10.5201 6.88223L15.3386 11.7007C15.6264 11.9886 15.6264 12.4553 15.3386 12.7431C15.0507 13.0309 14.584 13.0309 14.2962 12.7431L9.99892 8.44582L5.70163 12.7431C5.41379 13.0309 4.94709 13.0309 4.65924 12.7431Z",
    stroke: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.c9d3468aafbde1e10bc60fb73db912aa.svg";
export { ForwardRef as ReactComponent };